// Pie de página global. Se muestra en toda la app (dentro de Layout) y en las
// pantallas de acceso (Login, recuperar contraseña).
export default function Footer({ className = "" }) {
  return (
    <footer
      className={`px-4 py-4 text-center text-xs text-slate-400 ${className}`}
      data-testid="app-footer"
    >
      Desarrollado por Tomás Hirata ·{" "}
      <a href="tel:+522288471996" className="hover:text-slate-600 whitespace-nowrap">
        228 847 1996
      </a>
    </footer>
  );
}
